import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import backgroundImage from '../../assets/service_type/diagnozowanie.jpg';

const HeroContainer = styled.div`
  background: url(${backgroundImage}) no-repeat center center;
  background-size: cover;
  height: 80vh;
  display: flex;
  align-items: center;
  position: relative;
  color: white;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
`;

const HeroContent = styled(Row)`
  position: relative;
  z-index: 2;
  width: 100%;
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: 3.5rem;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  margin-bottom: 2rem;
`;

function Hero(props: RouteComponentProps) {
  return (
    <HeroContainer>
      <div className="container">
        <HeroContent>
          <Col md={8}>
            <Title>Profesjonalna opieka trychologiczna</Title>
            <Subtitle>Zadbaj o zdrowie swoich włosów i skóry głowy z naszymi specjalistami.</Subtitle>
            <Button variant="primary" size="lg" onClick={() => props.history.push('/wizyta')}>
              Umów wizytę
            </Button>
          </Col>
        </HeroContent>
      </div>
    </HeroContainer>
  );
}

export default withRouter(Hero);
